import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetAggregatedEventMerchantOrderDataByTypeQueryVariables = Types.Exact<{
  event_id: Types.Scalars['ID'];
  start_date?: Types.InputMaybe<Types.Scalars['String']>;
  end_date?: Types.InputMaybe<Types.Scalars['String']>;
  event_account_ids?: Types.InputMaybe<Array<Types.Scalars['ID']> | Types.Scalars['ID']>;
}>;


export type GetAggregatedEventMerchantOrderDataByTypeQuery = { __typename?: 'Query', getAggregatedEventMerchantOrderDataByType: { __typename?: 'GetAggregatedEventMerchantOrderDataByTypeResult', container_types: Array<{ __typename?: 'AggregatedEventMerchantOrderData', amount_containers_ordered: number, amount_container_stations_ordered: number, item_info: { __typename?: 'ItemInfo', id: string, name: string, image_url?: string | null, color_hex_code?: string | null } }> } };


export const GetAggregatedEventMerchantOrderDataByTypeDocument = gql`
    query GetAggregatedEventMerchantOrderDataByType($event_id: ID!, $start_date: String, $end_date: String, $event_account_ids: [ID!]) {
  getAggregatedEventMerchantOrderDataByType(
    event_id: $event_id
    start_date: $start_date
    end_date: $end_date
    event_account_ids: $event_account_ids
  ) {
    container_types {
      item_info {
        id
        name
        image_url
        color_hex_code
      }
      amount_containers_ordered
      amount_container_stations_ordered
    }
  }
}
    `;

/**
 * __useGetAggregatedEventMerchantOrderDataByTypeQuery__
 *
 * To run a query within a React component, call `useGetAggregatedEventMerchantOrderDataByTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAggregatedEventMerchantOrderDataByTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAggregatedEventMerchantOrderDataByTypeQuery({
 *   variables: {
 *      event_id: // value for 'event_id'
 *      start_date: // value for 'start_date'
 *      end_date: // value for 'end_date'
 *      event_account_ids: // value for 'event_account_ids'
 *   },
 * });
 */
export function useGetAggregatedEventMerchantOrderDataByTypeQuery(baseOptions: Apollo.QueryHookOptions<GetAggregatedEventMerchantOrderDataByTypeQuery, GetAggregatedEventMerchantOrderDataByTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAggregatedEventMerchantOrderDataByTypeQuery, GetAggregatedEventMerchantOrderDataByTypeQueryVariables>(GetAggregatedEventMerchantOrderDataByTypeDocument, options);
      }
export function useGetAggregatedEventMerchantOrderDataByTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAggregatedEventMerchantOrderDataByTypeQuery, GetAggregatedEventMerchantOrderDataByTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAggregatedEventMerchantOrderDataByTypeQuery, GetAggregatedEventMerchantOrderDataByTypeQueryVariables>(GetAggregatedEventMerchantOrderDataByTypeDocument, options);
        }
export type GetAggregatedEventMerchantOrderDataByTypeQueryHookResult = ReturnType<typeof useGetAggregatedEventMerchantOrderDataByTypeQuery>;
export type GetAggregatedEventMerchantOrderDataByTypeLazyQueryHookResult = ReturnType<typeof useGetAggregatedEventMerchantOrderDataByTypeLazyQuery>;
export type GetAggregatedEventMerchantOrderDataByTypeQueryResult = Apollo.QueryResult<GetAggregatedEventMerchantOrderDataByTypeQuery, GetAggregatedEventMerchantOrderDataByTypeQueryVariables>;